<template>
    <v-app>
        <v-main>
            <v-container fill-height>
                <v-row justify="center">
                    <v-col cols="12" md="4">
                        <v-sheet>
                            <v-row class="mb-4">
                                <v-col class="d-flex align-center">
                                    <div class="me-2">
                                        <v-icon size="60" color="warning">mdi-alert</v-icon>
                                    </div>
                                    <div>
                                        <h5 class="text-h5">Change Your Password</h5>
                                        <div class="text-subtitle-1">You must change your password</div>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-form ref="form">
                                <v-row>
                                    <v-col>
                                        <v-text-field
                                            label="Current Password"
                                            v-model="form.current_password"
                                            :rules="[isRequired]"
                                            outlined
                                            dense
                                            type="password"
                                            hide-details="auto"
                                            >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-text-field
                                            label="New Password"
                                            v-model="form.password"
                                            :rules="[isRequired, passwordRegex]"
                                            outlined
                                            dense
                                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="showPassword = !showPassword"
                                            :type="showPassword ? 'text' : 'password'"
                                            counter
                                            hide-details="auto"
                                            >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col>
                                        <v-text-field
                                            label="New Password Confirmation"
                                            v-model="form.password_confirmation"
                                            :rules="[isRequired, matchPassword]"
                                            outlined
                                            dense
                                            counter
                                            :append-icon="showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="showPasswordConfirmation = !showPasswordConfirmation"
                                            :type="showPasswordConfirmation ? 'text' : 'password'"
                                            hide-details="auto"
                                            >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col>
                                        <ul>
                                            <li>Lowercase & Uppercase</li>
                                            <li>Number (0-9)</li>
                                            <li>Atleast 8 Characters</li>
                                        </ul>
                                    </v-col>
                                </v-row>
                                <v-row >
                                    <v-col>
                                        <v-btn color="primary" @click="submit">
                                            CHANGE PASSWORD
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-sheet>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
        <v-snackbar :value="snackbar.display" @input="hideSnackbar" :color="snackbar.color" bottom right>{{snackbar.text}}</v-snackbar>
    </v-app>
</template>

<script>
import password from './../../services/administration/password';
import { mapActions, mapGetters } from 'vuex';
import { isRequired } from './../../utils/validations';

export default {
    data() {
        return {
            form: {
                username: null,
                current_password: null,
                password: null,
                password_confirmation: null
            },
            loading: false,
            showPassword: false,
            showPasswordConfirmation: false
        }
    },
    computed: {
        ...mapGetters({
            snackbar: "ui/snackbar/snackbar"
        }),
    },
    methods: {
        isRequired,
        ...mapActions({
            hideSnackbar: "ui/snackbar/hide"
        }),
        /**
         * 
         * @param {String} password 
         */
        passwordRegex(password) {
            if(!password) return;
            let found = password.match(/((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,}))/);
            if(found && found.length > 0) {
                return true;
            }
            return "Password is Weak";
            
        },
        matchPassword(passwordConfirmation) {
            if(!passwordConfirmation) return;
            if(passwordConfirmation == this.form.password) {
                return true;
            }
            return "Password Confirmation doesn't match"
        },
        submit() {
            if(!this.$refs.form.validate()) return;
            this.loading = false;
            password.changePasswordUntokened(this.form).then(() => {
                this.$router.replace({
                    path: "/auth/login"
                })
            }).finally(() => {
                this.loading = false;
            })
        }
    },
    created() {
        this.form.username = this.$route.query.username;
    }
}
</script>

<style>

</style>